<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-input v-model="query.fName" placeholder="名称" size="small" style="width:200px;" />
      <el-button type="primary" size="small" @click="refresh">查询</el-button>
      <el-button v-if="canAdd" type="primary" size="small" @click="_new">新增</el-button>
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table v-loading="loading" v-el-table-height-fix :data="tableData" height="100%">
        <el-table-column prop="fName" label="解决方案名称" />
        <el-table-column prop="fPrice" label="价格" />
        <el-table-column prop="fDes" label="解决方案说明" />
        <el-table-column label="操作" class-name="table-oper-col">
          <template slot-scope="scope">
            <template>
              <el-button type="text" size="small" @click="_modify(scope.row)">{{ (canEdit?'编辑':'查看') }}</el-button>
            </template>
            <template>
              <ConfirmButton v-if="canDel" @confirm="_delete(scope.row)">删除</ConfirmButton>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size.sync="query.pageSize"
        :page-sizes="[20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.pageRecordTotal"
        @size-change="refresh"
        @current-change="refresh"
      />
    </div>
  </div>
</template>
<script>
import ConfirmButton from '@components/ConfirmButton'

export default {
  components: {
    ConfirmButton
  },
  data() {
    return {
      query: {
        fName: null,

        pageIndex: 1,
        pageSize: 20
      },
      pageRecordTotal: 0,

      tableData: [],
      loading: false,
      currentEditItem: null,
      canAdd: true,
      canEdit: true,
      canDel: true
    }
  },
  mounted() {
    this.refresh()

    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants
    // console.log(userGrants,'userGrants')
    userGrants.forEach(val => {
      if (val.key == '002003002') {
        this.canAdd = val.isGrant
      }
      if (val.key == '002003003') {
        this.canEdit = val.isGrant
      }
      if (val.key == '002003004') {
        this.canDel = val.isGrant
      }
    })
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost('ICItemManage/ItemFa/ItemFaEntry', this.query).then((res) => {
        if (!res.isSuccess) {
          this.$message.error(res.message)
          return
        }

        this.tableData = res.datalist.dataEntry
        this.pageRecordTotal = res.datalist.total
      })
        .finally(() => this.loading = false)
    },
    _new: function() {
      const url = this.$route.path + '/' + 0
      this.$router.push(url)
    },
    _modify: function(row) {
      const url = this.$route.path + '/' + row.fItemFaID
      this.$router.push(url)
    },
    _delete(row) {
      this.loading = true
      return this.$httpPost(`ICItemManage/ItemFa/DeleteItemFa`, {
        fid: row.fItemFaID
      }).then(res => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refresh()
        } else {
          this.loading = false
          this.$message.error(res.message)
          throw res.message
        }
      })
    }
  }
}
</script>
